/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_DismissedInputs */

const en_inbox_dismissed = /** @type {(inputs: Inbox_DismissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismissed`)
};

const de_inbox_dismissed = /** @type {(inputs: Inbox_DismissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verworfen`)
};

/**
* | output |
* | --- |
* | "Dismissed" |
*
* @param {Inbox_DismissedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const inbox_dismissed = /** @type {((inputs?: Inbox_DismissedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_DismissedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_inbox_dismissed(inputs)
	return en_inbox_dismissed(inputs)
});